var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { useStore } from 'vuex-simple';
import { ValidationProvider } from 'vee-validate';
var ValidatedFieldMixin = /** @class */ (function (_super) {
    __extends(ValidatedFieldMixin, _super);
    function ValidatedFieldMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = useStore(_this.$store);
        _this.innerValue = '';
        return _this;
    }
    ValidatedFieldMixin.prototype.created = function () {
        if (this.value) {
            this.innerValue = this.value;
        }
    };
    /**
     * Handles internal model changes
     */
    ValidatedFieldMixin.prototype.onInnerValueChanged = function (val, oldVal) {
        this.$emit('input', val);
    };
    /**
     * Handles external model changes
     */
    ValidatedFieldMixin.prototype.onValueChanged = function (val, oldVal) {
        this.innerValue = this.value;
    };
    Object.defineProperty(ValidatedFieldMixin.prototype, "displayLabel", {
        get: function () {
            return this.fieldValidationRules.required && this.internalReadonly === false
                ? this.label + "*"
                : this.label;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidatedFieldMixin.prototype, "showDisplayHint", {
        get: function () {
            // hide if in read only mode
            if (this.internalReadonly) {
                return false;
            }
            // show if specifically added
            if (this.showDetails) {
                return true;
            }
            // show if text or validation rule
            if (this.displayHint.length > 0 || (this.fieldValidationRules && this.fieldValidationRules.max)) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidatedFieldMixin.prototype, "displayHint", {
        get: function () {
            if (this.hint && this.hint.length > 0) {
                return this.hint;
            }
            else if (this.fieldValidationRules.required) {
                return '*Required';
            }
            else {
                return '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidatedFieldMixin.prototype, "placedholderText", {
        get: function () {
            return this.placeholder && this.placeholder.length > 0
                ? this.placeholder
                : this.label;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidatedFieldMixin.prototype, "hideDetails", {
        get: function () {
            return this.showDisplayHint === false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidatedFieldMixin.prototype, "fieldValidationRules", {
        get: function () {
            return (this.validationRules ||
                this.store.managementPage.validationRules[this.name] ||
                {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidatedFieldMixin.prototype, "internalReadonly", {
        get: function () {
            return this.readonly || this.store.managementPage.readonly;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: null, required: true }),
        __metadata("design:type", String)
    ], ValidatedFieldMixin.prototype, "value", void 0);
    __decorate([
        Prop({ type: String, required: true }),
        __metadata("design:type", String)
    ], ValidatedFieldMixin.prototype, "name", void 0);
    __decorate([
        Prop({ type: String, required: true }),
        __metadata("design:type", String)
    ], ValidatedFieldMixin.prototype, "label", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], ValidatedFieldMixin.prototype, "placeholder", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], ValidatedFieldMixin.prototype, "hint", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], ValidatedFieldMixin.prototype, "readonly", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], ValidatedFieldMixin.prototype, "readonlyOverride", void 0);
    __decorate([
        Prop({ type: Object }),
        __metadata("design:type", Object)
    ], ValidatedFieldMixin.prototype, "validationRules", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], ValidatedFieldMixin.prototype, "showDetails", void 0);
    __decorate([
        Watch('innerValue', { immediate: true, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], ValidatedFieldMixin.prototype, "onInnerValueChanged", null);
    __decorate([
        Watch('value', { immediate: true, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], ValidatedFieldMixin.prototype, "onValueChanged", null);
    ValidatedFieldMixin = __decorate([
        Component({
            components: {
                'validation-provider': ValidationProvider,
            },
        })
    ], ValidatedFieldMixin);
    return ValidatedFieldMixin;
}(Vue));
export default ValidatedFieldMixin;
